import type { OperatingSystemJobEvent } from "@/lib/operating-systems";

const STALE_PROVIDER_MESSAGE_REPLY_CODES = new Set([
  "provider_message_not_actionable",
  "provider_message_not_found",
]);

const STALE_PROVIDER_MESSAGE_REPLY_MESSAGES = new Set([
  "this question is no longer waiting for a reply.",
  "a newer app message is available. refresh before replying.",
]);

export function isStaleProviderMessageReplyError(
  code: string | null,
  message: string | null | undefined = null,
): boolean {
  if (code && STALE_PROVIDER_MESSAGE_REPLY_CODES.has(code)) return true;
  return typeof message === "string" &&
    STALE_PROVIDER_MESSAGE_REPLY_MESSAGES.has(message.trim().toLowerCase());
}

export function providerMessageRequestsReply(value: unknown): boolean {
  if (typeof value !== "string") return false;
  const paragraphs = value
    .trim()
    .split(/\n\s*\n/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean);
  const closingParagraph = paragraphs.at(-1);
  if (!closingParagraph) return false;

  return /\?\s*(?:[*_`~)\]]+\s*)?$/.test(closingParagraph);
}

export function latestProviderMessageRequestsReply(
  events: OperatingSystemJobEvent[],
  activeJobId: string | null | undefined,
): boolean {
  if (!activeJobId) return false;
  const latestMessage = events
    .filter((event) =>
      event.job_id === activeJobId &&
      event.source === "base44_editor" &&
      event.event_type === "editor_message" &&
      event.role?.toLowerCase() === "assistant"
    )
    .sort((a, b) => {
      const observedDifference = new Date(a.observed_at).getTime() -
        new Date(b.observed_at).getTime();
      if (observedDifference) return observedDifference;
      return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
    })
    .at(-1);

  return providerMessageRequestsReply(latestMessage?.content);
}
